import { render, staticRenderFns } from "./codSettingListAction.vue?vue&type=template&id=155c95b8&scoped=true"
import script from "./codSettingListAction.vue?vue&type=script&lang=js"
export * from "./codSettingListAction.vue?vue&type=script&lang=js"
import style0 from "./codSettingListAction.vue?vue&type=style&index=0&id=155c95b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c95b8",
  null
  
)

export default component.exports